import React, { memo, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import { Typography, makeStyles, TextField } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
    root: {
        zIndex: "1310 !important"
    },
    title: {
        fontSize: "1.125rem",
        lineHeight: "1.25rem",
        fontWeight: 500,
        color: "#202124"
    },
    confirmButton: {
        color: "#fff",
        textTransform: "none",
        boxShadow: "none !important",
        backgroundColor: theme.palette.primary.main,
        "&:hover": {
            backgroundColor: `${theme.palette.primary.dark} !important`,
            color: theme.palette.primary.contrastText
        }
    },
    cancelButton: {
        textTransform: "none"
    }
}));

const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD;

function ConfirmPasswordDialog({
    open,
    handleClose,
    title = "This action requires admin rights",
    body = "Please enter the admin password to continue.",
    cancelText = "Cancel",
    confirmText = "Confirm",
    onConfirm
}) {
    const classes = useStyles();
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const onSubmit = async () => {
        setError("");
        if (password.trim() !== String(adminPassword).trim()) {
            setError("Incorrect password");
            return;
        }
        setPassword("");
        if (onConfirm) {
            await onConfirm();
        }
        handleClose();
    };

    return (
        <Dialog
            maxWidth="xs"
            open={open}
            classes={{ root: classes.root }}
            onClose={() => handleClose()}
            aria-labelledby="confirm-password-dialog"
        >
            <Box px={3} pt={3} pb={2}>
                <Typography className={classes.title} component="h2">
                    {title}
                </Typography>
            </Box>

            <Box pb={1.25} px={3}>
                <Typography variant="body2">{body}</Typography>
            </Box>

            <Box px={3} pb={1.25}>
                <form
                    autoComplete="off"
                    onSubmit={e => {
                        e.preventDefault();
                        onSubmit();
                    }}
                >
                    <TextField
                        label="Admin password"
                        type="password"
                        fullWidth
                        value={password}
                        onChange={event => setPassword(event.target.value)}
                        error={!!error}
                        helperText={error}
                        data-cy="confirm-password-input"
                        autoFocus
                        autoComplete="new-password"
                        inputProps={{ autoComplete: "new-password" }}
                    />
                </form>
            </Box>

            <DialogActions>
                <Button
                    onClick={() => {
                        setPassword("");
                        setError("");
                        handleClose();
                    }}
                    color="primary"
                    variant="outlined"
                    className={classes.cancelButton}
                >
                    {cancelText}
                </Button>

                <Button
                    onClick={onSubmit}
                    color="primary"
                    variant="contained"
                    disabled={!password.trim()}
                    className={classes.confirmButton}
                >
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog >
    );
}

export default memo(ConfirmPasswordDialog);
